<template>
  <div class="tabcl">
    <navigator :title="serviceName"></navigator>
    <van-tabs :active="active" @click="selectInvoiceType">
      <van-tab title="普通发票">
        <van-radio-group v-model="type" @change="selectType">
          <van-cell-group title="发票类型">
            <van-cell title="企业" clickable @click="type = 1">
              <van-radio :name="1" />
            </van-cell>
            <van-cell title="个人" clickable @click="type = 2">
              <van-radio :name="2" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-cell-group>
          <van-field label="发票抬头" v-model="invoiceTitle" required maxlength="50"/>
          <van-field label="纳税人识别号" v-model="creditCode" required v-if="type == 1" maxlength="50"/>
          <van-field label="收票人手机号" v-model="receiverMobile" required maxlength="11"/>
        </van-cell-group>
        <div class="footer">
          <mt-button class="myButton" @click="onSubmit" size="small">提交</mt-button>
        </div>
      </van-tab>
      <van-tab title="增值税发票">
        <van-cell-group>
          <van-field label="发票抬头" v-model="invoiceTitle" required maxlength="50"/>
          <van-field label="纳税人识别号" v-model="creditCode" required maxlength="50"/>
          <van-field label="注册地址" v-model="registerAddress" required maxlength="50"/>
          <van-field label="注册电话" v-model="registerTel" required maxlength="50"/>
          <van-field label="开户银行" v-model="bankName" required maxlength="50"/>
          <van-field label="银行账号" v-model="bankAccount" required maxlength="50"/>
          <van-field label="收票人手机号" v-model="receiverMobile" required maxlength="11"/>
        </van-cell-group>
        <div class="footer">
          <mt-button class="myButton" @click="onSubmit" size="small">提交</mt-button>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { jsTimestampFilter } from '@/utils/filters.js';
import deepcopy from '@/utils/deepcopy';
import { Toast } from 'vant';
export default {
  data() {
    return {
      invoiceId: 0,
      invoiceType: 1,
      active: 0,
      type: 1,
      receiverMobile: '',
      invoiceTitle: '',
      creditCode: '',
      registerAddress: '',
      registerTel: '',
      bankName: '',
      bankAccount: '',

      serviceName: '发票信息',  // 服务名称
    }
  },
  created() {
    if(this.$route.query.invoiceId){
      this.invoiceId = Number(this.$route.query.invoiceId);
      this.$http.post(`${this.URL_PREFIX}/app/get/user/invoice/info/detail`,{invoiceId: this.invoiceId,},{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          let invoice = res.data.resData;

          this.invoiceType = invoice.invoiceType;
          this.type = invoice.type;
          this.receiverMobile = invoice.receiverMobile;
          this.invoiceTitle = invoice.invoiceTitle;
          this.creditCode = invoice.creditCode;
          this.registerAddress = invoice.registerAddress;
          this.registerTel = invoice.registerTel;
          this.bankName = invoice.bankName;
          this.bankAccount = invoice.bankAccount;
          this.active = this.invoiceType-1;
        }else{
          Toast.fail({ duration: 1500, message: '未找到发票信息' });
        }
      })
    }
    this.selectType(this.type);
    if(!this.receiverMobile){
      if(this.localuser.userMobile){
        this.receiverMobile = this.localuser.userMobile;
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList', 'localuser']),
  },
  methods: {
    selectInvoiceType(name, title){
      if(title=='增值税发票'){
         this.invoiceType = 2;
      }else{
        this.invoiceType = 1;
      }
    },
    selectType(val){
      if(!this.invoiceTitle){
        if(val==1 || this.invoiceType==2){
          if(this.localuser.bindCorpInfo && this.localuser.bindCorpInfo.corpName){
            this.invoiceTitle = this.localuser.bindCorpInfo.corpName;
          }
        } else if(val==2){
          if(this.localuser.realName){
            this.invoiceTitle = this.localuser.realName;
          }
        }
      }
    },
    onSubmit(){
      if(!this.invoiceTitle){
        Toast.fail({ duration: 1500, message: '请完善信息' });
        return;
      }
      if (!/^1[3|4|5|7|8|9][0-9]\d{8}$/.test(this.receiverMobile)) {
        Toast('请填写正确的手机号');
        return;
      }
      let params = {
        receiverMobile: this.receiverMobile,
        invoiceTitle: this.invoiceTitle,
        invoiceType: this.invoiceType,
      }
      if(this.invoiceType==1){
        params.type = this.type;
        if(this.type==1){
          if(!this.creditCode){
            Toast.fail({ duration: 1500, message: '请完善信息' });
            return;
          }
          params.creditCode = this.creditCode;
        }
      }else{
        if(!this.creditCode || !this.registerAddress || !this.registerTel || !this.bankName || !this.bankAccount){
          Toast.fail({ duration: 1500, message: '请完善信息' });
          return;
        }
        params.creditCode = this.creditCode;
        params.registerAddress = this.registerAddress;
        params.registerTel = this.registerTel;
        params.bankName = this.bankName;
        params.bankAccount	 = this.bankAccount	;
      }

      if(!this.invoiceId){
        this.$http.post(`${this.URL_PREFIX}/app/added/user/invoice/info`, params, {
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            Toast.success({ duration: 1500, message: '添加成功' })
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          }else{
            Toast.fail({ duration: 1500, message: res.data.resDesc });
          }
        })
      }else{
        params.invoiceId = this.invoiceId;
        this.$http.post(`${this.URL_PREFIX}/app/modify/user/invoice/info`, params, {
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            Toast.success({ duration: 1500, message: '修改成功' })
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          }else{
            Toast.fail({ duration: 1500, message: res.data.resDesc});
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.tabcl{
  .van-tabs__line{
    background-color: #205eff;
  }
}
.footer{
  padding: px2rem(10) px2rem(32);
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  .myButton{
    width: 100%;
    background: #205eff;
    color: #fff;
    height: px2rem(78);
    font-size: px2rem(37);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/AddInvoice.vue